<div class="form-error-text">{{ errorMessage$ | async }}</div>
